export const Colors = {
    white: "#fff3f3",
    pink: "#e0527c",
    purple: "#47025d",
    lilac: "#8e7cc3",
    black: "#1c1c1c",
    blue: "#040471"
}